import React, { useState } from "react";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import "../style/components.css";
import { CardIcon, OvalStar } from "../constant";

const MainContainer = styled(Box)(({ theme }) => ({
    background: "#000",
    display: "flex",
    flexDirection: "column",
    padding: "60px 24px 90px 24px",
    position: "relative",
    overflow: "hidden",
    width: "100%",
    margin: "0 auto",

    "&::after": {
        content: '""',
        position: "absolute",
        width: "90%",
        height: "90%",
        left: "70%",
        top: "0",
        transform: "translateX(-100%), translateY(-50%)",
        background:
            "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
        filter: "blur(100px)",
       // backdropFilter: "blur(500px)",
        zIndex: 0,
    },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
    width: "100%", // Set to 95% width
    maxWidth: "1200px",
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
        width: "100%",
    },
}));

const CardsContainer = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    gap: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
        gap: theme.spacing(0),
        marginTop: theme.spacing(0),
    },
}));

const Card = styled(Box)(({ theme }) => ({
    background:
        "radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165, 239, 255, 0.2) 0%, rgba(110, 191, 244, 0.0447917) 77.08%, rgba(70, 144, 213, 0) 100%)",
    color: "white",
    borderRadius: 16,
    padding: theme.spacing(4),
    width: "100%",
    minHeight: 500,
    display: "flex",
    flexDirection: "column",
    transition: "all 0.3s ease-in-out",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    position: "relative",
    overflow: "hidden",
    marginTop: "12px",

    [theme.breakpoints.down("md")]: {
        minHeight: 450,
    },

    "&:hover": {
        transform: "translateY(-1px)",
        boxShadow: "0 15px 30px rgba(0,0,0,0.3)",
        border: "2px solid transparent",
        borderImageSource: `radial-gradient(80.38% 222.5% at -13.75% -12.36%, rgba(152, 249, 255, 0) 0%, rgba(255, 255, 255, 0) 100%),
                           radial-gradient(80.69% 208.78% at 108.28% 112.58%, rgba(234, 191, 255, 0) 0%, rgba(135, 38, 183, 0) 100%)`,
        borderImageSlice: 1,
    },
}));

const ThreeLongCard = ({ title, subTitle, data }) => {

    return (
        <MainContainer>
            <ContentContainer>
                <Box sx={{
                    width: { xs: "100%", md: "70%" },
                    textAlign: "center",
                    
                }}>
                    <Typography
                        variant="h2"
                        sx={{
                            background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            fontSize: { xs: "24px", sm: "32px", md: "40px" },
                            fontWeight: 700,
                            mb: { xs: 2, md: 4 },
                        }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        sx={{
                            color: "#8C8CC2",
                            fontSize: { xs: "16px", md: "18px" },
                            lineHeight: 1.8,
                            mb: { xs: 4, md: 8 },
                        }}
                    >
                        {subTitle}
                    </Typography>
                </Box>
                <CardsContainer>
                    <Grid container spacing={1} justifyContent="center">
                        {data?.map((card, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Card>
                                    <img
                                        src={card?.icon || CardIcon}
                                        alt="icon"
                                        style={{ width: 80, height: 80 }}
                                    />

                                    <Box
                                        sx={{
                                            textAlign: "left",
                                            flex: 1,
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "flex-end",
                                        }}
                                    >
                                        <Typography
                                            variant="h4"
                                            sx={{
                                                color: "#fff",
                                                fontSize: { xs: 24, md: 30 },
                                                fontWeight: 400,
                                                mb: 3,
                                                width:"70%"
                                            }}
                                        >
                                            {card.title}
                                        </Typography>

                                        {card?.listItems.map((item, idx) => (
                                            <Typography
                                                key={idx}
                                                variant="body1"
                                                sx={{
                                                    color: "#8C8CC2",
                                                    fontSize: { xs: 14, md: 18 },
                                                    lineHeight: 1.6,
                                                    mb: 1,
                                                }}
                                            >
                                                {idx + 1}. {" "}{item}
                                            </Typography>
                                        ))}
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </CardsContainer>

            </ContentContainer>
        </MainContainer>
    );
};

export default ThreeLongCard;